import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadOriginInPartCampaignProfile, leadOriginInPartCampaignProfilesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';

const LEAD_ORIGIN_IN_PART_CAMPAIGN_PROFILE_MODULE = 'leadOriginInPartCampaignProfile';

const leadOriginInPartCampaignProfileModuleInstance = getDataObjectsModule<ILeadOriginInPartCampaignProfile>(leadOriginInPartCampaignProfilesManager);
store.registerModule(LEAD_ORIGIN_IN_PART_CAMPAIGN_PROFILE_MODULE, leadOriginInPartCampaignProfileModuleInstance);

export { LEAD_ORIGIN_IN_PART_CAMPAIGN_PROFILE_MODULE };
